module.exports = __webpack_public_path__ + "media/assets/images/flags/bz-01ac58edc49d707d9a1dad6bebb3f940.svg";